import type { Ref } from 'vue'
import type { TSportEvent } from 'markets-store'
import { CYBER_SPORT_ID } from 'markets-store/constants'
import { sortBy } from '@st/utils'

type MaybeRef<T> = Ref<T> | T

export interface UseTopCyberEventsParams {
  quantity: MaybeRef<number>
}

export interface UseTopCyberEventsReturn {
  topCyberEvents: Readonly<Ref<TSportEvent[]>>
}

export function useTopCyberEvents({
  quantity,
}: UseTopCyberEventsParams): UseTopCyberEventsReturn {
  const sportEvents = useSportEvents()
  const topCyberEvents = computed(() => {
    const cyberEvents = sportEvents.value.filter(
      (event) => event.sport_id === CYBER_SPORT_ID,
    )
    const sortedCyberEvents = sortBy(cyberEvents, (event) => [
      event.weight,
      event.scheduled,
      event.id,
    ])
    return sortedCyberEvents.slice(0, unref(quantity))
  })

  return { topCyberEvents }
}
